'use strict';

const { removeItem } = require('public/js/lib/local-storage');
const STORAGE_KEYS = require('public/js/lib/storage-keys');

/**
 * Apply the currently selected dealer (returned by any location-update endpoint via
 * `LocationController::buildSelectedDealerPayload()`) to every DOM surface that displays
 * the selected dealer. Add new per-surface updaters here as more parts of the page become
 * reactive to dealer changes (PDP pricing, contact form dropdown, etc.).
 *
 * @param {{ name?: string, interactiveGarageDealerCode?: string }|null|undefined} dealer
 */
function applySelectedDealerToDom(dealer) {
	if (!dealer?.name) {
		return;
	}
	updateFindDealerTrigger(dealer);
	invalidateSupplierCache();
}

function clearFindDealerTrigger() {
	rp$('.find-dealer-text').each((_, element) => {
		const $element = rp$(element);
		const defaultText = $element.data('default-text');

		if (typeof defaultText === 'string') {
			$element.text(defaultText);
		}
	});
	rp$('.find-dealer-button').attr('data-ig-dealer-code', '');
}

function updateFindDealerTrigger(dealer) {
	// Match legacy dealer_selection_modal: name targets `.find-dealer-text` globally (not only under `.find-dealer-button`).
	rp$('.find-dealer-text').each((_, element) => {
		const $element = rp$(element);
		if (typeof $element.data('default-text') !== 'string') {
			$element.data('default-text', $element.text());
		}
		$element.text(dealer.name);
	});
	rp$('.find-dealer-button').attr('data-ig-dealer-code', dealer.interactiveGarageDealerCode ?? '');
}

/**
 * Drop the localStorage supplier cache so dealer_selection_modal's
 * `loadSelectedDealerOnPageLoad` can't repaint surfaces from stale data on the next load.
 */
function invalidateSupplierCache() {
	removeItem(STORAGE_KEYS.SUPPLIER_V1);
}

module.exports = {
	applySelectedDealerToDom,
	clearFindDealerTrigger,
	updateFindDealerTrigger,
};
